// extracted by mini-css-extract-plugin
module.exports = {"tags":"capabilities-tags-module--tags--iYmjK"};